export const NETWORK_ERROR = Symbol.for('network.error');
export const NETWORK_START = Symbol.for('network.start');
export const NETWORK_STOP  = Symbol.for('network.stop');

export const LOADING_START = Symbol.for('loader.start');
export const LOADING_STOP  = Symbol.for('loader.stop');
